<app-shared-loading *ngIf="loading"></app-shared-loading>

<div class="blockCard">
  <div class="container-user">

    <mat-card-title>
      {{ 'userData.title' | translate }}
    </mat-card-title>
    <br><br>

    <mat-card-subtitle>
      {{ 'userData.subtitle' | translate }}
    </mat-card-subtitle>
    <br><br><br>

    <mat-divider></mat-divider>

    <br>
    <p class="container-user">{{descriptionMultiLink}}</p>

    <mat-card-content>
      <form name="userData" class="notifyCard" id="userData" autocomplete="off">
        <div class="grid cols-2">
          <mat-form-field class="form-field" *ngIf="!merchantExistsFF">
            <mat-label>{{ 'userData.labelFullName' | translate }}</mat-label>
            <input
              #fullName
              type="text"
              name="fullName"
              [(ngModel)]="userDataModel.fullName"
              matInput [formControl]="fullNameFormControl"
              (keyup)="enableButton()"
              placeholder="{{ 'userData.placeholderFullName' | translate }}">
            <mat-hint align="end">{{fullName.value?.length || 0}}/{{fullNameMaxLength}}</mat-hint>
            <mat-error *ngIf="fullNameFormControl.hasError('required')">
              {{ 'userData.requiredFullName' | translate }} <strong>{{ 'generics.requiredTwo' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="fullNameFormControl.hasError('pattern')">
              {{ 'userData.specialCharacterFullName' | translate }}
            </mat-error>
            <mat-error *ngIf="fullNameFormControl.hasError('maxLength')">
              {{ 'userData.lengthInvalidFullName' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>{{ 'userData.labelEmail' | translate }}</mat-label>
            <input
              #email
              type="email"
              name="email"
              [(ngModel)]="userDataModel.email"
              matInput [formControl]="emailFormControl"
              (keyup)="enableButton()"
              placeholder="{{ 'userData.placeholderEmail' | translate }}">
            <mat-hint align="end">{{email.value?.length || 0}}/{{emailMaxLength}}</mat-hint>
            <mat-error *ngIf="emailFormControl.hasError('email')">
              {{ 'userData.invalidEmail' | translate }}
            </mat-error>
            <mat-error *ngIf="emailFormControl.hasError('required')">
              {{ 'userData.requiredEmail' | translate }} <strong>{{ 'generics.required' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="emailFormControl.hasError('maxLength')">
              {{ 'userData.lengthInvalidEmail' | translate }}
            </mat-error>
          </mat-form-field>

        </div>

        <div *ngIf="seeAmount" class="grid cols-2">

          <mat-form-field class="form-field">
            <mat-label>{{ 'userData.labelDescription' | translate }}</mat-label>
            <input
              #description
              type="text"
              name="description"
              [(ngModel)]="userDataModel.description"
              matInput [formControl]="descriptionFormControl"
              (keyup)="enableButton()"
              placeholder="{{ 'userData.placeholderDescription' | translate }}">
            <mat-hint align="end">{{description.value?.length || 0}}/{{descriptionMaxLength}}</mat-hint>
            <mat-error *ngIf="descriptionFormControl.hasError('required')">
              {{ 'userData.requiredDescription' | translate }} <strong>{{ 'generics.required' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="descriptionFormControl.hasError('pattern')">
              {{ 'userData.specialCharacterDescription' | translate }}
            </mat-error>
            <mat-error *ngIf="descriptionFormControl.hasError('maxLength')">
              {{ 'userData.lengthInvalidDescription' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>{{ 'userData.labelAmount' | translate }}</mat-label>
            <input
              #amount
              type="text"
              name="amount"
              [(ngModel)]="userDataModel.amount"
              matInput [formControl]="amountFormControl"
              (keyup)="enableButton()"
              placeholder="{{ 'userData.placeholderAmount' | translate }}">
            <mat-hint align="end">{{amount.value?.length || 0}}/{{amountMaxLength}}</mat-hint>
            <mat-error *ngIf="amountFormControl.hasError('required')">
              {{ 'userData.requiredAmount' | translate }} <strong>{{ 'generics.requiredTwo' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="amountFormControl.hasError('pattern')">
              {{ 'userData.specialCharacterAmount' | translate }}
            </mat-error>
            <mat-error *ngIf="amountFormControl.hasError('maxLength')">
              {{ 'userData.lengthInvalidAmount' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="!seeAmount" class="grid cols-1">

          <mat-form-field class="form-field">
            <mat-label>{{ 'userData.labelDescription' | translate }}</mat-label>
            <input
              #description
              type="text"
              name="description"
              [(ngModel)]="userDataModel.description"
              matInput [formControl]="descriptionFormControl"
              (keyup)="enableButton()"
              placeholder="{{ 'userData.placeholderDescription' | translate }}">
              <mat-hint *ngIf="description.value?.length < descriptionMaxLength " align="end">{{description.value?.length || 0}}/{{descriptionMaxLength}}</mat-hint>
              <mat-error *ngIf="description.value?.length > descriptionMaxLength ">{{ 'userData.lengthInvalidDescription' | translate }}</mat-error>
            <mat-error *ngIf="descriptionFormControl.hasError('required')">
              {{ 'userData.requiredDescription' | translate }} <strong>{{ 'generics.required' | translate }}</strong>
            </mat-error>
            <mat-error *ngIf="descriptionFormControl.hasError('pattern')">
              {{ 'userData.specialCharacterDescription' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <br>
        <div class="grid">
          <br>
          <button *ngIf="enableButtonContinue" mat-flat-button color="primary" (click)="sendData()">
            {{ 'generics.continue' | translate }}
          </button>
          <button *ngIf="!enableButtonContinue" mat-flat-button color="primary" disabled>
            {{ 'generics.continue' | translate }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </div>
</div>
